import { apiFetch } from './client';
import { getToken } from './client';

export const getStigLibrary   = (systemId)                    => apiFetch(`/stig/library?system_id=${systemId}`);
export const getAssetChecks   = (assetId, systemId, params={}) => apiFetch(`/stig/asset/${assetId}/checks?${new URLSearchParams({ system_id: systemId, ...params })}`);
export const getAssignedStigs = (assetId, systemId)            => apiFetch(`/stig/asset/${assetId}/assigned?system_id=${systemId}`);
export const applyStig        = (assetId, systemId, filename)  => apiFetch(`/stig/asset/${assetId}/apply?system_id=${systemId}`, { method: 'POST', body: JSON.stringify({ filename }) });
export const updateCheck      = (checkId, systemId, data)      => apiFetch(`/stig/check/${checkId}?system_id=${systemId}`, { method: 'PUT', body: JSON.stringify(data) });
export const bulkApplyStig    = (systemId, filename, asset_ids) =>
  apiFetch(`/stig/bulk-apply?system_id=${systemId}`, { method: 'POST', body: JSON.stringify({ filename, asset_ids }) });

export const uploadCkl = (assetId, systemId, file) => {
  const form = new FormData();
  form.append('file', file);
  const token = getToken();
  return fetch(`/api/stig/asset/${assetId}/upload-ckl?system_id=${systemId}`, {
    method: 'POST',
    body: form,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then(r => r.json());
};
